import React from 'react';
//import './NumberInput.css';

const RangeSlider = (props) => {
    
    const handleInputChange = (evt) => {
        const value = evt.target.value;
        props.onChange(value);
    }

    return (
        <div className='fields-container-inner' >
            <label 
                htmlFor={props.title}
                className='form-field-label'
            >
                <span>{props.description}</span>
                {props.unit ? (
                    <span>{props.symbol}{props.value} {props.unit}</span>
                ) : ''}
            </label>
            <input
                id={props.title}
                type={props.type}
                name={props.title}
                min={props.min}
                max={props.max}
                step={props.step}
                value={props.value}
                onChange={handleInputChange}
                required={props.required === 1 ? "required" : ''}
                className='input-number'
            />
            
            {props.unit ? (
                <output>{props.symbol}{props.value} {props.unit}</output>
            ) : ''}
            {props.helpTxt ? (
                <div className='helper'><p>{props.helpTxt}</p></div>
            ) : ''}
        </div>
    );
}

export default RangeSlider;